import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    // Set after the initial cards have rendered so their first paint isn't animated —
    // only cards appended later (via "load more") pick up the enter transition.
    this.setAttribute('initialized', '');
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
